/**
 * Owner: Masa Bayu
 * File: use-account-profile.ts
 * Date:Time: 2026-09-18 11:11
 * Description: Circle account profile — guest unless real session is attached.
 */

import {
  getQxCircleLocalAccount,
  getQxCircleSessionHandle,
  isQxCircleSignedIn,
} from '../engine/local-runtime';

export function useAccountProfile() {
  const account = getQxCircleLocalAccount();
  const signedIn = isQxCircleSignedIn();
  return {
    signedIn,
    displayName: signedIn ? (account?.profile.displayName.trim() || 'Member') : null,
    handle: getQxCircleSessionHandle(),
    accountId: account?.user.id ?? null,
  };
}
